import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

// Types
import { IPolicyInformationProps } from '../planSummary.types';

// Constants
import { enrollmentStatusMap } from '../planSummary.constants';

// Styles
import {
    StyledDd,
    StyledDl,
    StyledDt,
    StyledPlanSectionDataContainer,
    StyledPlanSectionHeader,
} from '../plansummary.styled';

// Components
import PaymentLink from './PaymentLink';

// Utilities
import { formatDate } from '../planSummary.utils';

const PolicyInformation = memo(({ plan }: IPolicyInformationProps) => {
    const mappedStatusKey = enrollmentStatusMap[plan.enrollmentStatus?.toUpperCase()];

    const enrollmentStatus = mappedStatusKey ? (
        <FormattedMessage id={`plansummary.enrollmentStatus.${mappedStatusKey}`} />
    ) : (
        plan.enrollmentStatus
    );

    return (
        <div data-testid="policy-information">
            <StyledPlanSectionHeader>
                <h5>
                    <FormattedMessage id="plansummary.policyinformation" />
                </h5>
            </StyledPlanSectionHeader>
            <StyledPlanSectionDataContainer>
                <StyledDl>
                    <StyledDt as="dt" data-testid="policy-id-label">
                        <FormattedMessage id="plansummary.policyid" />:
                    </StyledDt>
                    <StyledDd as="dd" data-testid="policy-id-value">
                        {plan.policyId || <FormattedMessage id="plansummary.na" />}
                    </StyledDd>

                    <StyledDt as="dt" data-testid="coverage-period-label">
                        <FormattedMessage id="plansummary.coverageperiod" />:
                    </StyledDt>
                    <StyledDd as="dd" data-testid="coverage-period-value">
                        {formatDate(plan.coverageStartDate)} - {formatDate(plan.coverageEndDate)}
                    </StyledDd>

                    <StyledDt as="dt" data-testid="enrollment-status-label">
                        <FormattedMessage id="plansummary.status" />:
                    </StyledDt>
                    <StyledDd as="dd" data-testid="enrollment-status-value">
                        {enrollmentStatus}
                    </StyledDd>
                </StyledDl>
                <PaymentLink plan={plan} />
            </StyledPlanSectionDataContainer>
        </div>
    );
});

PolicyInformation.displayName = 'PolicyInformation';
export default PolicyInformation;
